import {Entity} from '../core/entity/core.base.entity';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {LayerEntity} from './layer.entity';
import {SystemEntity} from './system.entity';
import {FolderEntity} from './folder.entity';
import {Column} from '../core/entity/core.entity.column';
import {EnvironmentKind} from "../enum/environment.kind";

@EntityTable('layer_system_xref', '54efa944-5f98-445c-9366-6224ac40bccf')
export class LayerSystemXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, LayerEntity, false, false, FieldRelationKind.BELONGS_TO, 'layer', 'aliasId', 'layerId')
    public layerId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Transient()
    public layer: LayerEntity;

    @Transient()
    public system: SystemEntity;

    @Transient()
    public folder: FolderEntity;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.BOOLEAN)
    public readOnly: boolean;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
